//
//
//
//
//
export default {
  props: {
    status: {
      type: Boolean,
      required: true
    }
  }
};